import React from 'react';
import styled from 'styled-components';

import { MOBILE_BREAKPOINT } from 'common/hooks/useIsMobile';
import { InsightEntity } from 'modules/insights-v2/types';

import OfflineIntervalSelector from './OfflineIntervalSelector';
import { OfflineInterval } from './types';

type OfflineTimeLayoutProps = {
  insightEntityType: InsightEntity['type'];
  offlineInterval: OfflineInterval;
  setOfflineInterval: (offlineInterval: OfflineInterval) => void;
  actions: React.ReactNode;
  children: React.ReactNode;
};

const ChartHeader = styled.div<{ perDay: boolean }>`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-self: stretch;
  gap: 16px;

  @media (max-width: ${MOBILE_BREAKPOINT}px) {
    ${({ perDay }) =>
      perDay &&
      `
    flex-direction: column;
  `};
  }
`;

const OfflineTimeLayoutContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-block: 24px;
  padding-inline: 16px;
  gap: 24px;
  width: 100%;
`;

const OfflineTimeLayout = ({
  insightEntityType,
  offlineInterval,
  setOfflineInterval,
  actions,
  children,
}: OfflineTimeLayoutProps) => {
  return (
    <OfflineTimeLayoutContainer>
      <ChartHeader perDay={offlineInterval === OfflineInterval.DAY}>
        {!['enterprise', 'brand'].includes(insightEntityType) && (
          <OfflineIntervalSelector
            insightEntityType={insightEntityType}
            offlineInterval={offlineInterval}
            onChange={setOfflineInterval}
          />
        )}
        {actions}
      </ChartHeader>
      {children}
    </OfflineTimeLayoutContainer>
  );
};

export default OfflineTimeLayout;
